<template>
  <div>
    <top-header
      :type="6"
      hasBorder="true"
      placeholder="申请挂牌"
      fontSize="0.32rem"
    />
    <div class="contain_ bor_b">
      <h3>房源基础信息</h3>
      <div class="info_con">
        <div class="inner">
          <p class="row m_flex_box">
            <span class="tit">所属城区：</span>
            <span class="text">{{ objs.area | zhXzqh }}</span>
          </p>
          <p class="row m_flex_box">
            <span class="tit">项目名称：</span>
            <span class="text">{{ objs.xmmc ? objs.xmmc : "-" }}</span>
          </p>
          <p class="row m_flex_box">
            <span class="tit">推广名称：</span>
            <span class="text">{{ objs.tgmc ? objs.tgmc : "-" }}</span>
          </p>
          <p class="row m_flex_box">
            <span class="tit">详细地址：</span>
            <span class="text">{{ objs.zl ? objs.zl : "-" }}</span>
          </p>
          <p class="row m_flex_box">
            <span class="tit">权属证类型：</span>
            <span class="text">{{ objs.qzbhType == 0 ? "房产证" : "不动产证" }}</span>
          </p>
          <p class="row m_flex_box">
            <span class="tit">{{ objs.qzbhType == 0 ? "房产证" : "不动产证" }}号：</span>
            <span class="text">{{ objs.qzbh ? objs.qzbh : "-" }}</span>
          </p>
          <p class="row m_flex_box" v-if="objs.qzbhType == 0">
            <span class="tit">土地证号<i class="col_red">*</i>：</span>
            <input class="flex-1" type="text" v-model="usuFructNo" placeholder="请输入土地证号">
          </p>
          <p class="row m_flex_box">
            <span class="tit">产权登记总面积： </span>
            <span class="text">{{ houseListed.zmjCount ? houseListed.zmjCount : "-" }}m²</span>
          </p>
          <p class="row m_flex_box">
            <span class="tit">房屋用途：</span>
            <span class="text">{{ houseListed.houseUse ? houseListed.houseUse : "-" }}</span>
          </p>
          <p class="row m_flex_box">
            <span class="tit">对应面积：</span>
            <span class="text">{{ houseListed.zmj ? houseListed.zmj : "-" }}</span>
          </p>
          <p class="row m_flex_box">
            <span class="tit">产权人姓名： </span>
            <span class="text">{{ cqr.syqr ? cqr.syqr : "-" }}</span>
          </p>
          <p class="row m_flex_box">
            <span class="tit">产权人身份证号： </span>
            <span class="text">{{ cqr.sfzh ? cqr.sfzh : "-" }}</span>
          </p>
          <div v-for="(item, index) in gyr" :key="index">
            <p class="row m_flex_box">
              <span class="tit">房屋共有人： </span>
              <span class="text">{{ item.syqr }}</span>
            </p>
            <p class="row m_flex_box">
              <span class="tit">房屋共有人身份证号：</span>
              <span v-if="item.cardTest" class="text">{{ item.sfzh}}</span>
              <input type="text" v-else class="flex-1" v-model="item.newSfz" placeholder="请输入正确的身份证号" maxlength="18">
            </p>
          </div>
        </div>
        <p class="blue_con">
          * 请核对身份信息，姓名与身份证号是否正确，身份信
          息错误将无法线上挂牌。
        </p>
      </div>
    </div>
    <div class="form_con">
      <div class="contain_ bor_b">
        <h3>挂牌房源信息</h3>
        <div class="inner_con">
          <div class="row m_flex_box flex_vc">
            <span class="tit">挂牌价格</span>
            <div class="row_r flex-1">
              <van-field maxlength="6" type="number" v-model="houseListed.listedPrice" label="" placeholder="请输入价格" >
                <template #extra>万元</template>
              </van-field>
            </div>
          </div>
          <div class="row m_flex_box flex_vc">
            <span class="tit">是否接受贷款</span>
            <div class="row_r flex-1">
              <van-radio-group v-model="houseListed.loan" direction="horizontal">
                <van-radio name="0">是</van-radio>
                <van-radio name="1">否</van-radio>
              </van-radio-group>
            </div>
          </div>
          <div class="row m_flex_box flex_vc">
            <span class="tit">户型</span>
            <div class="row_r flex-1">
              <van-field type="number" maxlength="2" v-model="houseListed.room" label="" placeholder="请输入" >
                <template #extra>室</template>
              </van-field>
            </div>
            <div class="row_r flex-1">
              <van-field type="number" maxlength="2" v-model="houseListed.hall" label="" placeholder="请输入" >
                <template #extra>厅</template>
              </van-field>
            </div>
            <div class="row_r flex-1">
              <van-field type="number" maxlength="2" v-model="houseListed.toilet" label="" placeholder="请输入" >
                <template #extra>卫</template>
              </van-field>
            </div>
          </div>
          <div class="row m_flex_box flex_vc">
            <span class="tit">总层数</span>
            <div class="row_r flex-1">
              <van-field type="number" maxlength="3" v-model="houseListed.totalLayer" label="" placeholder="请输入" >
                <template #extra>层</template>
              </van-field>
            </div>
          </div>
          <div class="row m_flex_box flex_vc">
            <span class="tit">所在层数</span>
            <div class="row_r flex-1">
              <van-field v-model="houseListed.locationLayer" maxlength="2" label="" placeholder="请输入" >
                <template #extra>层</template>
              </van-field>
            </div>
          </div>
          <div class="row m_flex_box flex_vc">
            <span class="tit">梯户比</span>
            <div class="row_r flex-1">
              <van-field type="number" v-model="houseListed.ladder" maxlength="2" label="" placeholder="请输入" >
                <template #extra>梯</template>
              </van-field>
            </div>
            <div class="row_r flex-1">
              <van-field type="number" v-model="houseListed.households" maxlength="3" label="" placeholder="请输入" >
                <template #extra>户</template>
              </van-field>
            </div>
          </div>
          <div class="row m_flex_box flex_vc">
            <span class="tit">房屋朝向</span>
            <div class="row_r flex-1">
              <van-field readonly clickable v-model="towards" @click="showDirection = true" label="" placeholder="房屋朝向" >
              </van-field>
              <van-popup v-model="showDirection" position="bottom">
                <van-picker
                  show-toolbar
                  value-key="t"
                  :columns="directionList"
                  @confirm="directionConfirm"
                  @cancel="showDirection = false"
                />
              </van-popup>
            </div>
          </div>
          <div class="row m_flex_box flex_vc">
            <span class="tit">装修情况</span>
            <div class="row_r flex-1">
              <van-field readonly clickable v-model="decoration" @click="showTrim = true" label="" placeholder="装修情况" >
              </van-field>
              <van-popup v-model="showTrim" position="bottom">
                <van-picker
                  show-toolbar
                  value-key="t"
                  :columns="trimList"
                  @confirm="trimConfirm"
                  @cancel="showTrim = false"
                />
              </van-popup>
            </div>
          </div>
          <div class="row m_flex_box flex_vc">
            <span class="tit">建成年代</span>
            <div class="row_r flex-1">
              <van-field v-model="houseListed.completionDate" maxlength="4" label="" placeholder="请输入建成年代" >
                <template #extra>年</template>
              </van-field>
            </div>
          </div>
          <div class="row m_flex_box flex_vc">
            <span class="tit">落户情况</span>
            <div class="row_r flex-1">
              <van-field readonly clickable v-model="settle" @click="showSettle = true" label="" placeholder="落户情况" >
              </van-field>
              <van-popup v-model="showSettle" position="bottom">
                <van-picker
                  show-toolbar
                  value-key="t"
                  :columns="settleList"
                  @confirm="settleConfirm"
                  @cancel="showSettle = false"
                />
              </van-popup>
            </div>
          </div>
          <div class="row m_flex_box flex_vc">
            <span class="tit">租赁情况</span>
            <div class="row_r flex-1">
              <van-radio-group v-model="houseListed.lease" direction="horizontal">
                <van-radio name="0">已租赁</van-radio>
                <van-radio name="1">未租赁</van-radio>
              </van-radio-group>
            </div>
          </div>
          <div class="row m_flex_box flex_vc">
            <span class="tit">暖气</span>
            <div class="row_r flex-1">
              <van-radio-group v-model="houseListed.heating" direction="horizontal">
                <van-radio name="0">有</van-radio>
                <van-radio name="1">无</van-radio>
              </van-radio-group>
            </div>
          </div>
          <div class="row m_flex_box flex_vc">
            <span class="tit">电梯</span>
            <div class="row_r flex-1">
              <van-radio-group v-model="houseListed.elevator" direction="horizontal">
                <van-radio name="0">有</van-radio>
                <van-radio name="1">无</van-radio>
              </van-radio-group>
            </div>
          </div>
          <div class="checkbox_con">
            <h5>家具</h5>
            <div class="check_inner">
              <span :class="item.checked ? 'active' : ''" @click="setVal('furnitureJson', index)" v-for="(item, index) in furnitureJson" :key="index">{{item.t}}</span>
            </div>
          </div>
          <div class="checkbox_con">
            <h5>家电</h5>
            <div class="check_inner">
              <span :class="item.checked ? 'active' : ''" @click="setVal('appliancesJson', index)" v-for="(item, index) in appliancesJson" :key="index">{{item.t}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="contain_ bor_b">
      <h3>房源特色</h3>
      <div class="inner_con">
        <div class="checkbox_con">
          <h5>房源标签</h5>
          <div class="check_inner">
            <span :class="item.checked ? 'active' : ''" @click="setVal('labelJson', index)" v-for="(item, index) in labelJson" :key="index">{{item.t}}</span>
          </div>
        </div>
        <div class="textarea_con">
          <h5>核心卖点</h5>
          <van-field
            v-model="featureJson[0].content"
            rows="4"
            label=""
            type="textarea"
            maxlength="150"
            placeholder="请输入想说的..."
            show-word-limit
          />
        </div>
        <div class="textarea_con">
          <h5>户型介绍</h5>
          <van-field
            v-model="featureJson[1].content"
            rows="4"
            label=""
            type="textarea"
            maxlength="150"
            placeholder="请输入想说的..."
            show-word-limit
          />
        </div>
        <div class="textarea_con">
          <h5>小区介绍</h5>
          <van-field
            v-model="featureJson[2].content"
            rows="4"
            label=""
            type="textarea"
            maxlength="150"
            placeholder="请输入想说的..."
            show-word-limit
          />
        </div>
        <div class="textarea_con">
          <h5>交通出行</h5>
          <van-field
            v-model="featureJson[3].content"
            rows="4"
            label=""
            type="textarea"
            maxlength="150"
            placeholder="请输入想说的..."
            show-word-limit
          />
        </div>
      </div>
    </div>
    <div class="contain_">
      <h3>房源图片<span class="col_ori">*请勿上传水印图片(最多上传12张)</span></h3>
      <div class="inner_con">
        <div class="pic_con m_flex_box flex_vw">
          <div class="inner flex_v flex_vc flex_hc" v-for="(item, index) in imgList" :key="index">
            <img class="show_img" :src="item.content" alt="">
            <img class="del" src="@/assets/img/del.png" @click="delImg(index)" alt="">
            <p class="m_flex_box flex_vc flex_hc" @click="chooseText(index)"><span>{{item.imgText ? item.imgText : '请选择图片类型'}}</span><van-icon name="play" /></p>
          </div>
          <div class="inner">
            <van-uploader :after-read="afterRead" :before-read="beforeRead" :max-count="12" />
          </div>
        </div>
      </div>
      <van-popup v-model="showText" position="bottom">
        <van-picker
          show-toolbar
          value-key="t"
          :columns="textList"
          @confirm="textConfirm"
          @cancel="showText = false"
        />
      </van-popup>
      <!-- <div class="inner_con">
        <div class="row m_flex_box flex_vc">
          <span class="tit">验证码</span>
          <div class="row_r flex-1">
            <van-field v-model="code" label="" placeholder="请输入验证码" >
              <template #extra>
                <img :src="codeImg" alt="" @click="getCodeIg">
              </template>
            </van-field>
          </div>
        </div>
      </div> -->
      <div class="btn_con">
        <p class="btn" @click="submit">立即挂牌</p>
      </div>
    </div>
    <div class="form_con">
    </div>
  </div>
</template>

<script>
import qs from 'qs'
import topHeader from "@/components/header";
export default {
  data() {
    return {
      flag: true,
      objs: {},
      houseListed:{
      },
      towards: '',
      decoration: '',
      settle: '',
      code: '',
      codeImg: '',
      //----------------------------------
      usuFructNo: '', //土地证号
      showDirection: false,
      directionList: [{
        v: 0,
        t: '东'
      },{
        v: 1,
        t: '西'
      },{
        v: 2,
        t: '南'
      },{
        v: 3,
        t: '北'
      },{
        v: 4,
        t: '东南'
      },{
        v: 5,
        t: '西南'
      },{
        v: 6,
        t: '东北'
      },{
        v: 7,
        t: '西北'
      }],
      showTrim: false,
      trimList: [{
        v: 0,
        t: '毛坯'
      },{
        v: 1,
        t: '简装'
      },{
        v: 2,
        t: '精装'
      }],
      showSettle: false,
      settleList: [{
        v: 0,
        t: '已落户、待迁出'
      },{
        v: 1,
        t: '曾落户、已迁出'
      },{
        v: 2,
        t: '至今未落户'
      }],
      showText: false,
      textList: [{
        v: 0,
        t: '客厅'
      },{
        v: 1,
        t: '卧室'
      },{
        v: 2,
        t: '厨房'
      },{
        v: 3,
        t: '卫生间'
      },{
        v: 4,
        t: '餐厅'
      },{
        v: 5,
        t: '地下室'
      },{
        v: 6,
        t: '阁楼'
      },{
        v: 7,
        t: '阳台'
      },{
        v: 8,
        t: '露台'
      },{
        v: 9,
        t: '其他'
      },{
        v: 'a',
        t: '封面图'
      },{
        v: 'c',
        t: '户型图'
      }],
      imgList: [],
      imgIndex: 0,
      cqr: {},
      gyr: [],
      furnitureJson: [{
        v: 0,
        t: '床'
      },{
        v: 1,
        t: '沙发'
      },{
        v: 2,
        t: '衣柜'
      },{
        v: 3,
        t: '餐桌'
      },{
        v: 4,
        t: '茶几'
      },{
        v: 5,
        t: '电视机柜'
      },{
        v: 6,
        t: '鞋柜'
      }],
      appliancesJson: [{
        v: 0,
        t: '电视'
      },{
        v: 1,
        t: '冰箱'
      },{
        v: 2,
        t: '空调'
      },{
        v: 3,
        t: '洗衣机'
      },{
        v: 4,
        t: '热水器'
      },{
        v: 5,
        t: '电脑'
      },{
        v: 6,
        t: '灶具'
      }],
      labelJson: [],
      featureJson: [{
        featureType: 0,
        content: ''
      },{
        featureType: 1,
        content: ''
      },{
        featureType: 2,
        content: ''
      },{
        featureType: 3,
        content: ''
      }],
      rules: [{
        v: 'listedPrice',
        t: '请输入挂牌价格'
      },{
        v: 'loan',
        t: '请选择是否接受贷款'
      },{
        v: 'room',
        t: '请完善户型信息'
      },{
        v: 'hall',
        t: '请完善户型信息'
      },{
        v: 'toilet',
        t: '请完善户型信息'
      },{
        v: 'totalLayer',
        t: '请输入总层数'
      },{
        v: 'locationLayer',
        t: '请输入所在层数'
      },{
        v: 'ladder',
        t: '请完善梯户比信息'
      },{
        v: 'towards',
        t: '请选择房屋朝向'
      },{
        v: 'decoration',
        t: '请选择装修情况'
      },{
        v: 'completionDate',
        t: '请输入建成年代'
      },{
        v: 'settle',
        t: '请选择落户情况'
      },{
        v: 'lease',
        t: '请选择租赁情况'
      },{
        v: 'heating',
        t: '请选择有无暖气'
      },{
        v: 'elevator',
        t: '请选择有无电梯'
      },]
    };
  },
  components: {
    topHeader
  },
  filters: {
    zhXzqh (data){
      if (data === "320302") {
        return "鼓楼区";
      } else if (data === "320311") {
        return "泉山区";
      } else if (data === "320303") {
        return "云龙区";
      } else if (data === "320398") {
        return "金山桥";
      } else if (data === "320312") {
        return "铜山区";
      } else if (data === "320305") {
        return "贾汪区";
      } else if (data === "320399") {
        return "高新区";
      } else if (data == '320397') {
        return '港务区';
      } else if (data === "320382") {
        return "邳州市";
      } else if (data === "320381") {
        return "新沂市";
      } else if (data === "320321") {
        return "丰县";
      } else if (data === "320324") {
        return "睢宁";
      } else if (data === "320322") {
        return "沛县";
      } else if (data === "320") {
        return "市区";
      }
    }
  },
  mounted() {
    this.getDetail();
    this.getCodeIg();      
  },
  methods: {
    getCodeIg() {
      // this.codeImg = `${process.env.VUE_APP_BASE_API}code/getLoginCode.do?${ Math.random()}`
      this.codeImg = `${window.location.host}code/getLoginCode.do?${ Math.random()}`
    },
    submit() {
      if(this.objs.qzbhType == 0 && !this.usuFructNo) {
        this.$toast('请输入土地证号');
        return;
      }
      for(let i =0; i < this.gyr.length; i++) {
        if(!this.gyr[i].cardTest && !this.filterCardNum(this.gyr[i].newSfz)) {
          this.$toast(`共有人${this.gyr[i].syqr}的身份证号格式错误`);
          return;
        }
      }
      for (let i = 0; i < this.rules.length; i++) {
        for(let key in this.houseListed) {
          if (this.rules[i].v == key) {
            if (this.houseListed[key] === '' || this.houseListed[key] === null) {
              this.$toast(this.rules[i].t);
              return;
            }
          }
        }
      }
      var date = new Date()
      if(this.houseListed.completionDate * 1 < 1970) {
        this.$toast('建成年份不得小于1970');
        return
      }
      if(this.houseListed.completionDate * 1 > date.getFullYear()) {
        this.$toast('建成年份不得大于当前年份');
        return
      }
      if(!this.imgList.length) {
        this.$toast('请上传房源图片');
        return;
      }
      if(!this.flag) {
        return false
      }
      this.flag = false;
      const ownerInfos = {};
      this.gyr.forEach(item => {
        if(!item.cardTest) {
          const name = item.syqr
          ownerInfos[name] = item.newSfz
        }
      });
      const furnitureJson = [];
      this.furnitureJson.forEach(item => {
        if(item.checked) {
          furnitureJson.push({
            furnitureType: item.v
          })
        }
      });
      const appliancesJson = [];
      this.appliancesJson.forEach(item => {
        if(item.checked) {
          appliancesJson.push({
            appliancesType: item.v
          })
        }
      });
      const labelJson = [];
      this.labelJson.forEach(item => {
        if(item.checked) {
          labelJson.push({
            labelType: item.v
          })
        }
      });
      const imgJson = [];
      this.imgList.forEach(item => {
        imgJson.push({
          imgName: item.imgName,
          base64Img: item.imgName,
          imgSuffix: '',
          imgType: item.imgType,
        })
      });
      const imgType = imgJson.some(item => {
        return item.imgType === 'a'
      });
      if(!imgType) {
        imgJson[0].imgType = 'a'
      };
      const {...houseListedJson} = this.houseListed;
      houseListedJson.listedPrice = this.houseListed.listedPrice * 10000
      const obj = {
        area: this.$route.query.area,
        mainId: this.$route.query.mainId,
        usuFructNo: this.usuFructNo,
        code: this.code,
        ownerInfos: JSON.stringify(ownerInfos),
        houseListedJson: JSON.stringify(houseListedJson),
        furnitureJson: JSON.stringify(furnitureJson),
        appliancesJson: JSON.stringify(appliancesJson),
        labelJson: JSON.stringify(labelJson),
        featureJson: JSON.stringify(this.featureJson),
        imgJson: JSON.stringify(imgJson)
      };
      this.$http.post('cms/houseListed/reg/doHouseListed.do', qs.stringify(obj)).then(res => {
        this.flag = true
        if(res.success) {
          this.$dialog.alert({
            title: '提示',
            message: res.msg
          }).then(() => {
            this.$router.go(-1)
          });
        } else{
          this.flag = true;
          this.$dialog.alert({
            title: '提示',
            message: res.msg
          })
        }
      }).catch(() => {
        this.flag = true
      })
    },
    getDetail() {
      this.$http.post('cms/sfzhHouseMain/reg/getHouseForListed.do', qs.stringify({
        mainId: this.$route.query.mainId,
        type: this.$route.query.type,
        area: this.$route.query.area,
        listedId: this.$route.query.listedId
      })).then(res => {
        this.objs = res.attributes.houseMain;
        this.houseListed = res.attributes.houseListed;
        this.$set(this.houseListed, 'totalLayer', res.attributes.houseSublist.layerNum);
        this.$set(this.houseListed, 'locationLayer', res.attributes.houseSublist.localLayer);
        const labelJson = [];
        res.attributes.houseLabel.forEach(item => {
          labelJson.push({
            v: item.dictValue,
            t: item.dictKey
          })
        });
        this.labelJson = labelJson;
        let cqrIndex = null
        this.gyr = res.attributes.saleApplyInfo.houseOwnerInfos;
        this.gyr.forEach((item, index) => {
          if(item.isSyr === '0') {
            this.cqr = item;
            cqrIndex = index;
          }
          item.cardTest = this.filterCardNum(item.sfzh);
          item.newSfz = '';
        });
        this.gyr.splice(cqrIndex, 1);
      })
    },
    filterCardNum(id) {
      const REG = /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
      return REG.test(id)
    },
    directionConfirm(data) {
      this.showDirection = false;
      this.$set(this.houseListed, 'towards', data.v);
      this.towards = data.t;
    },
    trimConfirm(data) {
      this.showTrim = false;
      this.$set(this.houseListed, 'decoration', data.v);
      this.decoration = data.t;
    },
    settleConfirm(data) {
      this.showSettle = false;
      this.$set(this.houseListed, 'settle', data.v);
      this.settle = data.t;
    },
    textConfirm(data) {
      const imgFlag = this.imgList.some(item => {
        return item.imgType === 'a'
      });
      if(imgFlag && data.v === 'a') {
        this.$toast('已经有一个封面了');
        return
      }
      this.showText = false;
      this.$set(this.imgList[this.imgIndex], 'imgType', data.v);
      this.$set(this.imgList[this.imgIndex], 'imgText', data.t);
    },
    chooseText(index) {
      this.imgIndex = index;
      this.showText = true;
    },
    beforeRead(file) {
      if (file.type.toLowerCase() !== 'image/jpg' && file.type.toLowerCase() !== 'image/png' && file.type.toLowerCase() !== 'image/jpeg' && file.type.toLowerCase() !== 'image/gif') {
        this.$toast('该格式不支持');
        return false;
      } else if (file.size > 8000 * 1024) {
        this.$toast('文件大小不得超过8M');
        return false;
      }
      return true;
    },
    afterRead(file) {
      const formData = new FormData();
      formData.append("upImg", file.file);
      this.$http({
        url: 'cms/houseListed/reg/upImg.do',
        method: 'POST',
        headers: { //添加请求头
          "Content-Type": "multipart/form-data",
        },
        data: formData,
      }).then((res) => {
        this.$toast(res.msg);
        if(res.success) {
          this.imgList.splice(0, 0, {
            imgName: res.obj,
            base64Img: res.obj,
            imgSuffix: '',
            imgType: '9',
            content: file.content
          })
        }
      })
    },
    delImg(index) {
      this.imgList.splice(index, 1)
    },
    setVal(arr, index) {
      if(arr === 'labelJson') {
        let num = 0;
        this.labelJson.forEach(item => {
          if(item.checked) {
            num += 1;
          }
        });
        if(num > 2 && !this[arr][index]['checked']) {
          this.$toast('房源标签最多只能选3项');
          return
        }
      }
      this.$set(this[arr][index], 'checked', !this[arr][index]['checked'])
    },
  }
};
</script>
<style lang="less" scoped>
.contain_ {
  padding-bottom: 1px;
  .blue_con{
    background-color: #EFF4FF;
    width: 7.04rem;
    margin: 0 auto 0.4rem;
    padding: 0.16rem 0.4rem;
    box-sizing: border-box;
    color: #2F72F5;
    font-size: 0.26rem;
    line-height: 0.4rem;
  }
  h3 {
    font-size: 0.34rem;
    font-weight: 800;
    padding: 0.4rem 0 0rem;
    width: 7.04rem;
    margin: 0 auto;
  }
}
.info_con {
  margin: 0rem auto 0rem;
  width: 7.04rem;
  .inner {
    padding: 0.3rem 0;
    font-size: 0.26rem;
    border-bottom: 1px solid #f5f5f5;
    p {
      margin-bottom: 0.2rem;
      line-height: 0.42rem;
    }
    .tit {
      box-sizing: border-box;
      color: #909090;
    }
    .text {
      max-width: 70%;
    }
  }
}
.inner_con{
  width: 7.04rem;
  font-size: 14px;
  margin: 0 auto;
  overflow: hidden;
  .tit{
    width: 1.9rem;
    font-weight: 800;
  }
  .row{
    min-height: 44px;
    border-bottom: 1px solid #f5f5f5;
    .van-radio-group{
      padding-left: 16px;
    }
  }
}
.checkbox_con, .textarea_con{
  padding: 0.4rem 0 0.2rem;
  overflow: hidden;
  border-bottom: 1px solid #f5f5f5;
  h5{
    font-weight: 800;
    font-size: 14px;
    margin-bottom: 0.3rem;
  }
  .check_inner{
    margin-right: -0.16rem;
    span{
      line-height: 0.52rem;
      padding: 0 12px;
      background-color: #F2F2F2;
      color: #989898;
      display: inline-block;
      margin-bottom: 0.16rem;
      margin-right: 0.16rem;
      &.active{
        background-color: rgb(0,123,255);
        color: #fff;
      }
    }
  }
}
.textarea_con{
  /deep/
  .van-cell{
    background-color: #F8F8F8;
  }
}
.col_ori{
  color: #FF3C1C;
  font-size: 0.26rem;
  font-weight: 400;
  margin-left: 10px;
}
.pic_con{
  padding-top: 0.3rem;
  padding-bottom: 0.2rem;
  margin-right: -0.2rem;
  .inner{
    height: 2.66rem;
    margin-right: 0.2rem;
    margin-bottom: 0.2rem;
    position: relative;
    .show_img{
      width: 2.2rem;
      height: 2.2rem;
    }
    .del{
      position: absolute;
      width: 0.4rem;
      top: 0.16rem;
      right: 0.16rem;
    }
    p{
      width: 2.2rem;
      height: 0.46rem;
      color: #606060;
      font-size: 0.22rem;
      box-sizing: border-box;
      border: 1px solid #E0E0E0;
      .van-icon{
        transform: rotate(90deg);
      }
    }
  }
}
/deep/
.van-uploader__upload{
  width: 2.2rem;
  height: 2.2rem;
  margin: 0;
}
.btn_con{
  padding: 0rem 0 0.6rem;
}
.btn{
  border-radius: 0.08rem;
  background-color: #2F72F5;
  line-height: 0.74rem;
  text-align: center;
  color: #fff;
  font-size: 0.28rem;
  width: 7.04rem;
  margin: 0 auto;
}
</style>